module.exports = __webpack_public_path__ + "static/media/document-week3.67c5e4a3.pdf";